export default __webpack_public_path__ + "static/burger_bg_logo-14a71c5e9f510e9bc607a66d2d4bb222.png";